module.exports = __webpack_public_path__ + "static/media/efeito-sonoro.c13f1d3a.wav";